/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { Errors } from 'state/shared/types';

import type {
  CreateAccountDto,
  CreateAccountSuccess,
  CreateAccountFailure,
  SendVerificationEmailDto,
  SendVerificationEmailSuccess,
  SendVerificationEmailFailure,
  VerifyAccountDto,
  VerifyAccountSuccess,
  VerifyAccountFailure,
  SetupPasswordDto,
  SetupPasswordFailure,
  AccountDetailsDto,
  AccountDetailsFailure,
} from './signUpStepsTypes';

export type SliceState = {
  currentStep: number;
  isValid: boolean;
  pending: boolean;
  errors: Errors;
  currentUser: string | null;
  verificationToken: string | null; // TODO: Remove when email sending is sorted out
};

export const initialState: SliceState = {
  currentStep: 0,
  isValid: false,
  pending: false,
  errors: [],
  currentUser: null,
  verificationToken: null, // TODO: Remove when email sending is sorted out
};

const signUpStepsSlice = createSlice({
  name: 'signUpSteps',
  initialState,
  reducers: {
    CREATE_ACCOUNT_REQUEST(state, _action: PayloadAction<CreateAccountDto>) {
      state.pending = true;
    },
    CREATE_ACCOUNT_SUCCESS(state, action: PayloadAction<CreateAccountSuccess>) {
      state.pending = false; // TODO: bug fix for MW-10947 make this not set the flag (so spinner keeps spinning for slow connections)
      state.errors = [];
      state.currentUser = action.payload.username;
    },
    CREATE_ACCOUNT_FAILURE(state, action: PayloadAction<CreateAccountFailure>) {
      state.pending = false;
      state.errors.push(action.payload);
    },
    SEND_VERIFICATION_EMAIL_REQUEST(
      state,
      _action: PayloadAction<SendVerificationEmailDto>
    ) {
      state.pending = true;
    },
    SEND_VERIFICATION_EMAIL_SUCCESS(
      state,
      action: PayloadAction<SendVerificationEmailSuccess>
    ) {
      state.pending = false;
      state.errors = [];
      state.verificationToken = action.payload.verificationToken; // TODO: Remove when email sending is sorted out
    },
    SEND_VERIFICATION_EMAIL_FAILURE(
      state,
      action: PayloadAction<SendVerificationEmailFailure>
    ) {
      state.pending = false;
      state.errors.push(action.payload);
    },
    VERIFY_ACCOUNT_REQUEST(state, _action: PayloadAction<VerifyAccountDto>) {
      state.pending = true;
    },
    VERIFY_ACCOUNT_SUCCESS(state, action: PayloadAction<VerifyAccountSuccess>) {
      state.pending = false;
      state.errors = [];
      state.currentUser = action.payload.username;
    },
    VERIFY_ACCOUNT_FAILURE(state, action: PayloadAction<VerifyAccountFailure>) {
      state.pending = false;
      state.errors.push(action.payload);
    },
    UPDATE_STEP(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    UPDATE_VALIDATION(state, action: PayloadAction<boolean>) {
      state.isValid = action.payload;
    },
    SETUP_PASSWORD_REQUEST(state, _action: PayloadAction<SetupPasswordDto>) {
      state.pending = true;
    },
    SETUP_PASSWORD_SUCCESS(state, _action: PayloadAction) {
      state.pending = false;
      state.errors = [];
    },
    SETUP_PASSWORD_FAILURE(state, action: PayloadAction<SetupPasswordFailure>) {
      state.pending = false;
      state.errors.push(action.payload);
    },
    ACCOUNT_DETAILS_REQUEST(state, _action: PayloadAction<AccountDetailsDto>) {
      state.pending = true;
    },
    ACCOUNT_DETAILS_SUCCESS(state, _action: PayloadAction) {
      state.pending = false;
      state.errors = [];
    },
    ACCOUNT_DETAILS_FAILURE(
      state,
      action: PayloadAction<AccountDetailsFailure>
    ) {
      state.pending = false;
      state.errors.push(action.payload);
    },
    RESET_SIGNUPSTEPS_STATE: () => initialState,
  },
});

export const signUpStepsActions = signUpStepsSlice.actions;

export default signUpStepsSlice.reducer;
